/* Anayam — stat counter count-up on scroll (vanilla, no libraries).
   The rotating announcement bar is handled by Horizon's native section. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var counters = document.querySelectorAll('[data-anayam-count]');
  if (!counters.length) return;

  var animate = function (el) {
    var raw = el.getAttribute('data-anayam-count');
    var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
    var prefix = raw.match(/^[^0-9]*/)[0];
    var suffix = raw.match(/[^0-9,.]*$/)[0];
    var hasComma = raw.indexOf(',') > -1;
    if (isNaN(target) || reduce) { el.textContent = raw; return; }
    var start = null, dur = 1400;
    var step = function (ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(target * eased);
      el.textContent = prefix + (hasComma ? val.toLocaleString('en-US') : val) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    };
    requestAnimationFrame(step);
  };

  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); }
    });
  }, { threshold: 0.4 });
  counters.forEach(function (c) { io.observe(c); });
})();

/* Header nav self-heal after a window resize.
   Horizon's <overflow-list> wraps its ResizeObserver in ResizeNotifier, which
   swallows the first callback after each reconnect. Because #reflowItems
   disconnects while it measures, any size change landing in that window is
   dropped — so dragging the window narrow and back can leave menu items stuck
   under "More". Re-dispatching the component's own `reflow` event once the
   resize settles restores the correct layout. */
(function () {
  var lists = document.querySelectorAll('overflow-list');
  if (!lists.length) return;
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      lists.forEach(function (list) {
        list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
      });
    }, 200);
  }, { passive: true });
})();
